<section class="toggle-form assign-skills-slider" [ngClass]="{ active: isAssignSkillsSliderOpen }">
  <div class="formwrap" #assignSkillsFormWrap>
    <div class="header">
      <h2><b>{{ headerText }}</b></h2>
      <p-button appPreventDoubleClick styleClass="p-button-text" id="assignSkillsSliderCloseBtn" type="button" label="Close" (debounceClick)="closeSlider()"></p-button>
    </div>

    <div class="content-wrapper">
      <div class="trainingItems">
        <!-- Assigned Skills Section (Current + To Assign) -->
        <p-fieldset legend="Assigned Skills" [toggleable]="true" class="first-fieldset">
          <div class="col mb-2">
            <!-- Currently Assigned Skills + Skills to Assign -->
            <div class="card-container" *ngIf="!isLoadingAssignedSkills && selectedSkills.length > 0">
              <div class="items-container" *ngFor="let skill of selectedSkills">
                <div class="overflow-ellipse flex-initial flex underline document-header font-semibold">
                  <a class="underline blue-color cursor-pointer" (click)="viewSkillDetails(skill?.code, skill?.name)" [title]="skill?.name">
                    {{ skill?.code }} {{ skill?.name || 'Skill' }}
                  </a>
                </div>
                <div class="overflow-ellipse flex-initial flex" style="text-align: right;">
                  <button
                    pButton
                    pRipple
                    type="button"
                    id="deleteLinkedItemButton"
                    icon="fa fa-trash"
                    appPreventDoubleClick
                    class="p-button-rounded p-button-text"
                    (debounceClick)="removeSelectedSkill(skill)">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>

        <!-- Search Skills Section -->
        <p-fieldset legend="Search Skills" [toggleable]="true" class="second-fieldset">
          <div class="second-fieldset-content">
            <app-skill-search
              [enableSelection]="true"
              [selectionIdField]="'code'"
              (selectedSkillsChange)="onSelectedSkillsChange($event)"
              (searchStateChange)="onSearchStateChange($event)">
            </app-skill-search>
          </div>
          <div class="col mb-2 mt-2">
            <p-button
              *ngIf="hasSearched && hasSearchResults"
              appPreventDoubleClick
              label="Assign Skill"
              icon="fa fa-plus"
              id="assignSkillButton"
              styleClass="p-button-outlined"
              iconPos="left"
              pTooltip="Assign Skill"
              (debounceClick)="assignSelectedSkills()"
              [disabled]="isAssignSkillButtonDisabled">
            </p-button>
          </div>
        </p-fieldset>
      </div>

      <div class="button">
        <p-button appPreventDoubleClick label="Save" type="submit" id="assignSkillsSaveBtn" class="align-right" styleClass="bpt-button-compact" (debounceClick)="saveAssignedSkills()" [disabled]="isSaving || !hasNewSkillsToSave"></p-button>
      </div>
    </div>
  </div>

  <!-- Dialog Components -->
  <app-removal-reason-dialog
    [display]="removeReasonDialogVisible"
    [skillName]="selectedSkillForRemoval?.name || selectedSkillForRemoval?.code || ''"
    (onConfirm)="onRemovalReasonConfirm($event)"
    (onCancel)="onRemovalReasonCancel()">
  </app-removal-reason-dialog>

  <app-revocation-dialog
    [display]="revocationDialogVisible"
    [skillCode]="selectedSkillForRemoval?.code || ''"
    [skillName]="selectedSkillForRemoval?.name || selectedSkillForRemoval?.code || ''"
    (onConfirm)="onRevocationConfirm($event)"
    (onCancel)="onRevocationCancel()">
  </app-revocation-dialog>
</section>
